/**
 * Meldet unbehandelte Browser-Fehler an den eigenen Server.
 *
 * Ohne das hinterlässt ein Fehler im Editor nur eine Zeile in einer
 * Browser-Konsole, die niemand ansieht — der Nutzer meldet dann „geht nicht"
 * und die Ursache ist weg. Der Server loggt die Meldung und zählt sie in
 * `cs2_client_errors_total`.
 */
const endpoint = "/api/client-errors";
const maxReportsPerSession = 10;
let sent = 0;
const seen = new Set<string>();

function report(message: string, stack: string | undefined): void {
  // Ein Fehler in einer Render-Schleife feuert sonst hunderte Requests.
  const fingerprint = `${message}::${stack?.split("\n")[1] ?? ""}`;
  if (sent >= maxReportsPerSession || seen.has(fingerprint)) return;
  seen.add(fingerprint);
  sent += 1;
  const body = JSON.stringify({
    message,
    stack: stack ?? "",
    url: window.location.pathname,
  });
  // `sendBeacon` überlebt auch einen Tab, der sich gerade schließt.
  if (navigator.sendBeacon) {
    navigator.sendBeacon(
      endpoint,
      new Blob([body], { type: "application/json" }),
    );
    return;
  }
  void fetch(endpoint, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => undefined);
}

export function installErrorReporting(): void {
  window.addEventListener("error", (event) => {
    report(
      event.message,
      event.error instanceof Error ? event.error.stack : undefined,
    );
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason: unknown = event.reason;
    report(
      reason instanceof Error ? reason.message : String(reason),
      reason instanceof Error ? reason.stack : undefined,
    );
  });
}
